import { CheckIcon, DeleteIcon, RepeatIcon } from '@chakra-ui/icons';
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  IconButton,
  Tooltip,
  useDisclosure,
} from '@chakra-ui/react';
import { synchronizationAction } from 'actions';
import { updateCurrentConnection } from 'actions/synchronization';
import { CONNECTION_STATUS } from 'helpers/constant';
import { useAppDispatch } from 'hooks';
import { SharepointConnection, useDeleteConnection } from 'queries/useConnection';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

function ConnectionActionButtons({ info }: { info: SharepointConnection }) {
  const { t } = useTranslation();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = useRef<any>();
  const handleConfirmConsent = async (consentLink?: string) => {
    if (consentLink) {
      window.location.href = consentLink;
    }
  };
  const dispatch = useAppDispatch();

  const { mutate: deleteConnection, isPending: isDeleting } = useDeleteConnection();
  const handleDelete = async (name: string) => {
    deleteConnection(name);
  };
  return (
    <div>
      <Tooltip
        isDisabled={info.status_code === 'Connected'}
        label={t('connection.confirmConnection')}
      >
        <IconButton
          mr={1}
          aria-label={t('connection.confirmConnection')}
          colorScheme='green'
          icon={<CheckIcon />}
          isDisabled={info.status_code === CONNECTION_STATUS.CONNECTED || isDeleting}
          onClick={() => handleConfirmConsent(info.consent_link)}
          size='sm'
        />
      </Tooltip>
      <Tooltip label={t('connection.syncFolder')}>
        <Link
          to={`/sync-projects`}
          onClick={() => {
            dispatch(updateCurrentConnection(info.id));
            dispatch(synchronizationAction.resetProject());
          }}
        >
          <IconButton
            mr={1}
            aria-label={t('connection.syncFolder')}
            colorScheme='purple'
            icon={<RepeatIcon />}
            isDisabled={info.status_code !== CONNECTION_STATUS.CONNECTED || isDeleting}
            size='sm'
          />
        </Link>
      </Tooltip>
      <Tooltip label={t('connection.deleteConnection')}>
        <IconButton
          mr={1}
          aria-label={t('connection.deleteConnection')}
          colorScheme='red'
          icon={<DeleteIcon />}
          isLoading={isDeleting}
          onClick={() => onOpen()}
          size='sm'
        />
      </Tooltip>
      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
        returnFocusOnClose={false}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize='lg' fontWeight='bold'>
              {t('connection.deleteConnection')}
            </AlertDialogHeader>

            <AlertDialogBody>{t('connection.deleteConnectionConfirmation')}</AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                {t('common.cancel')}
              </Button>
              <Button
                ml={3}
                colorScheme='red'
                onClick={() => {
                  handleDelete(info.id);
                  onClose();
                }}
              >
                {t('common.delete')}
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </div>
  );
}

export default ConnectionActionButtons;
